import React, { useState, useEffect } from 'react';
import './ModalUker.css';
import InputOption from '../InputOption/InputOption';

const ModalUker = ({ data, show, onClose, onChange }) => {
    if (!show) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h4 className='text-black'>Unit Kerja</h4>
                    <button className="close-button" onClick={onClose}>
                        &times;
                    </button>
                </div>
                <div className="modal-body">
                    <InputOption
                        label="Pilih Unit"
                        data={data}
                        placeholder="Ketik disini"
                        onChange={onChange} />
                </div>
            </div>
        </div>
    );
};

export default ModalUker;
